import React from 'react';
import HubIntegrationsListPageContainer from './hubIntegrationsListPageContainer';

export class HubIntegrationsListPage extends React.Component{
    
    render(){
      return (
        <HubIntegrationsListPageContainer {...this.props}/>
      )
    }
}